import Cookies from 'js-cookie'
import {aesEncrypt} from '@/utils/crypto'

export function setCookie1(){
	//console.log(aesEncrypt('99'))
	return Cookies.set('username',aesEncrypt('9999'),{
		expires: 365*100,
		path:'/'
	})
}

export function setCookie2(){
	//console.log(aesEncrypt('123'))
	return Cookies.set('userpwd',aesEncrypt('123456'),{
		expires: 365*100,
		path:'/'
	})
}

export const getCookie=(key)=>{
	return Cookies.get(key)
}

export const removeCookie=(key)=>{
	return Cookies.remove(key,{
		path: '/'
	})
}